import {
  BasketballEventStatusId,
  BasketballResultId,
} from '@collector/sportsapi-client-legacy'

import { ResultWithSliderConfig } from '../../configuration'

const resultIdToAcronymMap = new Map<BasketballResultId, string>([
  [BasketballResultId.FirstQuarter, 'Q1'],
  [BasketballResultId.SecondQuarter, 'Q2'],
  [BasketballResultId.ThirdQuarter, 'Q3'],
  [BasketballResultId.FourthQuarter, 'Q4'],
  [BasketballResultId.FirstOvertime, 'OT 1'],
  [BasketballResultId.SecondOvertime, 'OT 2'],
  [BasketballResultId.ThirdOvertime, 'OT 3'],
  [BasketballResultId.FourthOvertime, 'OT 4'],
  [BasketballResultId.FifthOvertime, 'OT 5'],
])

const eventStatusToResultIdMap = new Map<
  BasketballEventStatusId,
  BasketballResultId
>([
  [BasketballEventStatusId.FirstQuarter, BasketballResultId.FirstQuarter],
  [BasketballEventStatusId.SecondQuarter, BasketballResultId.SecondQuarter],
  [BasketballEventStatusId.ThirdQuarter, BasketballResultId.ThirdQuarter],
  [BasketballEventStatusId.FourthQuarter, BasketballResultId.FourthQuarter],
  [BasketballEventStatusId.FirstOvertime, BasketballResultId.FirstOvertime],
  [BasketballEventStatusId.SecondOvertime, BasketballResultId.SecondOvertime],
  [BasketballEventStatusId.ThirdOvertime, BasketballResultId.ThirdOvertime],
  [BasketballEventStatusId.FourthOvertime, BasketballResultId.FourthOvertime],
  [BasketballEventStatusId.FifthOvertime, BasketballResultId.FifthOvertime],
])
export const resultWithSliderConfig: ResultWithSliderConfig<
  BasketballResultId,
  BasketballEventStatusId
> = {
  resultIdToAcronymMap,
  eventStatusToResultIdMap,
  showCurrentResult: true,
}
